import { GLOBAL_RULESET, GLOBAL_RULESET_VERSION, GLOBAL_SOURCES } from "@moneymap/country-global";
import { INDIA_RULESET, INDIA_RULESET_VERSION, INDIA_SOURCES } from "@moneymap/country-in";
import type { FinancialFacts, FinancialPlan, SourceReference, SupportedCountryCode } from "@moneymap/domain";
import { FINANCIAL_ENGINE_VERSION, runFinancialPlanEngine, type CountryRuleSet } from "@moneymap/rules-core";

export { FINANCIAL_ENGINE_VERSION, GLOBAL_RULESET_VERSION, INDIA_RULESET_VERSION };

const LOCAL_COUNTRY_RULESETS: readonly CountryRuleSet[] = [INDIA_RULESET];

export function ruleSetForCountry(country: SupportedCountryCode): CountryRuleSet {
  return LOCAL_COUNTRY_RULESETS.find((ruleSet) => ruleSet.matchesCountry(country)) ?? GLOBAL_RULESET;
}

export function buildPlan(input: FinancialFacts, now = new Date()): FinancialPlan {
  return runFinancialPlanEngine(ruleSetForCountry(input.country), input, now);
}

export function currentRulesetVersion(country: SupportedCountryCode): string {
  return ruleSetForCountry(country).version;
}

export function getPlanSource(id: string): SourceReference | undefined {
  return INDIA_SOURCES[id] ?? GLOBAL_SOURCES[id];
}
